<template>
  <TemplateRegistro :titulo="titulo" :texto="texto" @intro="submit()">
    <label for="uname1">
      <strong>E-mail</strong>
    </label>
    <input
      id="uname1"
      v-model.trim="email1"
      type="email"
      placeholder="Escribe tu email"
      required
      onselectstart="return false"
      onpaste="return false;"
      oncopy="return false"
      oncut="return false"
      ondrag="return false"
      ondrop="return false"
      autocomplete="off"
    />

    <label for="uname2">
      <strong>Repite tu e-mail</strong>
    </label>
    <input
      id="uname2"
      v-model.trim="email2"
      type="email"
      placeholder="Repite tu email"
      required
      onselectstart="return false"
      onpaste="return false;"
      oncopy="return false"
      oncut="return false"
      ondrag="return false"
      ondrop="return false"
      autocomplete="off"
    />

    <PanelMensajes :mensaje="error" clase="error" />

    <div v-if="false">
      <br />
      <input v-model="okCorreoVerde" type="checkbox" class="aceptacion" />
      Aplicar este e-mail a todas mis pólizas.
    </div>

    <button type="submit" class="pure-button ripple" @click.prevent="submit()">
      <strong>Terminar</strong>
    </button>
  </TemplateRegistro>
</template>

<script>
/* eslint-disable */
export default {
  data() {
    return {
      okCorreoVerde: true,
      email1: "",
      email2: "",
      error: "",
      titulo: "Comunicación Email",
      texto: "Indícanos tu e-mail para mejorar nuestra comunicación contigo",
    };
  },

  methods: {
    validarEmail() {
      console.log("Validar email");
      let expresionRegular = /^[-\w.%+]{1,64}@(?:[A-Z0-9-]{1,63}\.){1,125}[A-Z]{2,63}$/i;
      this.error = "";

      if (this.email1.length < 1 || this.email2.length < 1) {
        this.error = "Escriba su e-mail en las dos casillas";
        return;
      }

      if (this.email1.trim() != this.email2.trim()) {
        this.error = "Los e-mail no son iguales";
        return;
      }

      if (!expresionRegular.test(this.email1)) {
        this.error = "E-mail incorrecto";
        return;
      }
    },

    modificarPolizas: async function () {
      let polizasAplicar = [];

      let lstVeh = this.$store.state.portfolio.lstPolizasVeh;
      lstVeh.forEach((element) => {
        polizasAplicar.push(element.idPoliza);
      });

      let lstHogar = this.$store.state.portfolio.lstPolizasHogar;
      lstHogar.forEach((element) => {
        polizasAplicar.push(element.idPoliza);
      });

      let result = await this.$store.dispatch("actualizarEmail", {
        idCliente: this.$store.state.portfolio.idCliente,
        email: this.email1,
        polizas: polizasAplicar,
      });

      if (result.codigo != 0) {
        this.error = result.mensaje;
        return;
      }
      await this.$store.dispatch("getPortfolio");
    },

    modificarCliente: async function () {
      let result = await this.$store.dispatch("actualizarEmail", {
        idCliente: this.$store.state.portfolio.idCliente,
        email: this.email1,
        polizas: null,
      });

      if (result.codigo != 0) {
        this.error = result.mensaje;
        return;
      }

      this.$store.dispatch("getPortfolio");
    },

    hayGdprPdte() {
      let cliente = this.$store.state.portfolio.cliente;
      let gdprEmpresas = cliente.gdprEmpresas;
      return gdprEmpresas == null;
    },

    submit: async function () {
      this.validarEmail();
      if (this.error != "") return;

      if (this.okCorreoVerde) {
        console.log("okCorreoVerde: " + this.okCorreoVerde);
        await this.modificarPolizas();
      } else {
        console.log("okCorreoVerde: " + this.okCorreoVerde);
        // FIXME Cambiar por modificarPolizas por modificarCliente cuando el servidor este preparado
        await this.modificarPolizas();
      }

      if (this.error != "") return;

      if (this.hayGdprPdte()) {
        this.$router.push({ name: "gdprTacito" });
      } else this.$router.replace({ name: "inicio" });
    },
  },
};
</script>

<style lang="scss" scoped>
.aceptacion {
  font-size: 0.85rem;
}
</style>
